import { render, staticRenderFns } from "./Pageconfigure.vue?vue&type=template&id=c945c864&scoped=true"
import script from "./Pageconfigure.vue?vue&type=script&lang=js"
export * from "./Pageconfigure.vue?vue&type=script&lang=js"
import style0 from "./Pageconfigure.vue?vue&type=style&index=0&id=c945c864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c945c864",
  null
  
)

export default component.exports